// AI Assistant allowlist - Commit Estimator team members and selected pilot users
const AI_ASSISTANT_ALLOWED_EMAILS = [
  'kpurkayastha@confluent.io',
  'mpati@confluent.io',
  'adeorha@confluent.io',
  'atomar@confluent.io',
  'dnidwannaya@confluent.io',
  'mmoole@confluent.io',
  'mmalani@confluent.io',
  'mangupta@confluent.io',
  'mbhatv@confluent.io',
  'ngeorgejacob@confluent.io',
  'vgundamaraju@confluent.io',
  'prsingh@confluent.io',
  'tbrennan@confluent.io',
  'mdunn@confluent.io',
  'vjeevaraj@confluent.io',
  'msannella@confluent.io',
  'vsalzman@confluent.io',
  'croach@confluent.io',
  'gcunningham@confluent.io',
  'graj@confluent.io',
  'wgreen@confluent.io',
  'kevin.chao@confluent.io',
  'scwong@confluent.io',
  'nmuddana@confluent.io',
  'rong@confluent.io',
  'marmstrong@confluent.io',
  'ehagen@confluent.io',
  'mdudek@confluent.io',
  'ssawant@confluent.io',
];

export const AI_ASSISTANT_ALLOWED_EMAILS_BY_ENV = {
  local: AI_ASSISTANT_ALLOWED_EMAILS,
  devel: AI_ASSISTANT_ALLOWED_EMAILS,
  stag: AI_ASSISTANT_ALLOWED_EMAILS,
};

// Stacking order within the assistant. The TopBar and the modal dimmer sit above
// all three — see src/constants.js.
export const Z_INDEX_LAUNCHER = 1200;
export const Z_INDEX_DRAWER = 1201;
export const Z_INDEX_RESIZE_HANDLE = 1202;

// How many conversations the history panel fetches per page. The service pages by
// cursor through an index, so this bounds the request rather than the reachable
// history -- there is no date cutoff, and "Load older chats" walks back as far as
// the user has.
export const HISTORY_PAGE_SIZE = 25;

// The "bad response" feedback modal opens on top of everything else in the
// assistant, including the app's own modal dimmer (Z_INDEX_MODAL_DIMMER in
// src/constants.js), since it's the most recent thing the user interacted with.
export const Z_INDEX_FEEDBACK_MODAL = 1500;

// Starter prompts shown on the empty chat welcome screen
export const EXAMPLE_PROMPTS = [
  "What's the difference between eCKU and CKU, and which cluster types use each?",
  'Add a Standard cluster in eu-west-1, 200 MB/s in and 600 MB/s out',
  'Show me the estimates I created, newest first',
  'Start an estimate for a 3-year AWS deal on private networking',
  "What's changed between the tiered pricing rate card and the older 4/11/2024 one?",
];

// Wiki page for AskCommit capabilities
export const CAPABILITIES_URL =
  'https://confluentinc.atlassian.net/wiki/spaces/PM/pages/6231752857/What+AskCommit+can+and+can+t+do+Beta';

// Slack channel for pricing questions
export const PRICING_SLACK_URL = 'https://confluent.slack.com/channels/pricing-911';
